import React from 'react';
import classNames from 'classnames';
import Alert from '../Alert';

export type AlertType = 'info' | 'error' | 'success';

export interface TitleBannerProps extends React.HTMLAttributes<HTMLElement> {
  // TODO: GET TYPE FROM ALERT COMPONENT
  alertMessage?: string;
  alertProps?: object;
  alertType?: AlertType;
  backgroundImages?: string[];
  className?: string;
  notificationMessage?: string;
  notificationType?: string;
  notificationLoaded?: boolean;
  onClose?: React.ReactEventHandler;
  title: string;
}

const TitleBanner: React.FunctionComponent<TitleBannerProps> = ({
  alertMessage,
  alertProps,
  alertType,
  backgroundImages = [],
  className,
  notificationMessage,
  notificationType = '',
  notificationLoaded = false,
  onClose,
  title
}) => {
  const imgs = backgroundImages.map(img => `url(${img})`).join(', ');
  return (
    <div
      className={classNames(
        'ribbon',
        className,
        alertMessage && 'ribbon--has-alert',
        notificationMessage && '-has-notification'
      )}
    >
      <div className='ribbon__image' style={{ backgroundImage: imgs }} />
      <div className='container container-fluid'>
        {alertMessage && (
          <Alert alertType={alertType} onClose={onClose} {...alertProps}>
            {alertMessage}
          </Alert>
        )}
        <h1 className='ribbon__heading'>{title}</h1>
      </div>
      {notificationMessage && (
        <div
          className={classNames(
            'ribbon__notification',
            notificationType && `-${notificationType}`,
            notificationLoaded && '-loaded'
          )}
        >
          {notificationMessage}
        </div>
      )}
    </div>
  );
};

export default TitleBanner;
